<!--  -->
<template>
  <div>
    <el-form
      :label-position="labelPosition"
    >
      <el-form-item label="标题">
        <el-input v-model="title" />
      </el-form-item>
      <el-form-item label="备注">
        <el-input v-model="remark" />
      </el-form-item>
      <el-form-item label="过期时间">
        <el-date-picker
          v-model="expiration_time"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="datetime"
          :picker-options="pickerOptions"
          placeholder="选择日期时间"
        />
        <!-- <el-select v-model="expiration_day" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select> -->
      </el-form-item>
      <el-form-item label="微信链接地址">
        <div class="dkweq">
          <!-- <el-input
            v-model="url"
            style="width:400px;margin-right:10px"
            placeholder="输入微信链接导入到富文本"
          /> -->
          <el-button
            type="primary"
            size="mini"
            @click="daowe"
          >导入微信链接到富文本</el-button>
        </div>
      </el-form-item>
      <el-form-item label="内容">
        <el-button
          type="primary"
          size="mini"
          style="margin-bottom:10px"
          @click="chaweimg"
        >插入图片</el-button>
        <el-button
          type="primary"
          size="mini"
          style="margin-bottom:10px"
          @click="searchr"
        >插入企微二维码</el-button>
        <el-button
          type="primary"
          size="mini"
          style="margin-bottom:10px"
          @click="chahuolink"
        >插入获客链接</el-button>
        <Editor-wang
          ref="editorwangfour"
          v-model="html_text"
        />
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="sumbirwe"
        >确定</el-button>
      </el-form-item>
    </el-form>

    <el-dialog
      title="选择图片"
      :visible.sync="choicedialogVisibleimg"
      :append-to-body="true"
      :modal-append-to-body="true"
      :destroy-on-close="true"
      width="30%"
    >
      <selectImage @callbackimgs="callbackimgs" />
    </el-dialog>
    <el-dialog
      title="选择二维码"
      :visible.sync="erweidialog"
      :append-to-body="true"
      :modal-append-to-body="true"
      :destroy-on-close="true"
      width="50%"
    >
      <erweima
        ref="erweimaview"
        @callbackerweima="callbackerweima"
      />
    </el-dialog>
    <el-dialog
      v-loading="loading"
      title="输入微信链接导入到富文本"
      :visible.sync="dialogVisiblejdnjaknjw"
      :append-to-body="true"
      :modal-append-to-body="true"
      width="30%"
      :before-close="handleClose"
      element-loading-text="导入中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
      <el-input
        v-model="url"
        placeholder="输入微信链接导入到富文本"
      />
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="dawimport">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="编辑获客链接"
      :visible.sync="huokedialog"
      :append-to-body="true"
      :modal-append-to-body="true"
      :destroy-on-close="true"
      width="30%"
    >
      <!-- :destroy-on-close="true" -->
      <sethuokelink @callbackhuoke="callbackhuoke" />
    </el-dialog>
  </div>
</template>

<script>
import EditorWang from './AboutView.vue'
import selectImage from '../../accountPush/components/selectImage.vue'
import erweima from './erweima.vue'
import { iqiyipromotionlinkcreateone, iqiyipromotionlinkcreatedetails, iqiyipromotionlinkeditone, iqiyipromotionlikkwqewq } from '@/api/officialaccount.js'
import sethuokelink from './sethuokelink.vue'
export default {
  components: { EditorWang, selectImage, erweima, sethuokelink },
  data() {
    return {
      labelPosition: 'right',
      title: '',
      html_text: '',
      choicedialogVisibleimg: false,
      type: null,
      erweidialog: false,
      html_no: null,
      url: '',
      loading: false,
      dialogVisiblejdnjaknjw: false,
      huokedialog: false,
      remark: '',
      // options: [
      //   { value: 0, label: '不限' },
      //   { value: 1, label: '1天' },
      //   { value: 2, label: '2天' },
      //   { value: 3, label: '3天' },
      //   { value: 4, label: '4天' },
      //   { value: 5, label: '5天' },
      //   { value: 6, label: '6天' },
      //   { value: 7, label: '7天' }
      // ],
      // expiration_day: 2
      expiration_time: null,
      pickerOptions: {
        // 禁用当前日期之前的日期
        disabledDate(time) {
          // Date.now()是javascript中的内置函数，它返回自1970年1月1日00:00:00 UTC以来经过的毫秒数。
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      upload_html_number: null
    }
  },
  created() {},
  mounted() {},
  methods: {
    send(type, item) {
      console.log(type, item)
      this.type = type
      if (this.type === 2 || this.type === 3) {
        this.detail(item)
      }
    },
    detail(item) {
      iqiyipromotionlinkcreatedetails({
        html_no: item.html_no
      }).then(res => {
        this.html_text = res.data.detail.html_text
        this.title = res.data.detail.title
        this.html_no = res.data.detail.html_no
        this.upload_html_number = res.data.detail.upload_html_number
        if (this.type === 2) {
          this.remark = res.data.detail.remark
        } else {
          this.remark = res.data.detail.remark + '-复用'
        }
        // eslint-disable-next-line eqeqeq
        this.expiration_time = res.data.detail.expiration_time == 0 ? null : res.data.detail.expiration_time
        console.log('res', res)
      })
    },
    chaweimg() {
      this.choicedialogVisibleimg = true
    },
    callbackimgs(item, type) {
      this.choicedialogVisibleimg = false
      console.log(item, type)
      // eslint-disable-next-line eqeqeq
      if (type == 1) {
        this.$refs.editorwangfour.send(item, 1)
        // eslint-disable-next-line eqeqeq
      } else if (type == 2) {
        // console.log(this.encodeSearchKey(item.link))
        this.$refs.editorwangfour.send(item, 6)
      }
    },
    callbackerweima(item, type) {
      console.log(item, type)
      this.erweidialog = false
      this.$refs.editorwangfour.send(item, 7)
    },
    searchr() {
      this.erweidialog = true
      this.$nextTick(() => {
        this.$refs.erweimaview.send()
      })
    },
    sumbirwe() {
      if (this.title === '') {
        this.$message({
          message: '请填写标题',
          type: 'error'
        })
        return
      }
      if (this.html_text === '') {
        this.$message({
          message: '请填写内容',
          type: 'error'
        })
        return
      }
      const enhancedHtml = this.html_text
      // 处理 <img> 标签
        .replace(/(<img[^>]*?)style="([^"]*?)"/gi, (_, start, style) => {
          const cleanedStyle = style
            .replace(/width\s*:[^;]+;?/gi, '')
            .replace(/height\s*:[^;]+;?/gi, '')
            .replace(/max-width\s*:[^;]+;?/gi, '')
            .replace(/overflow-wrap\s*:[^;]+;?/gi, '')
            .trim()

          const newStyle = `max-width: 100% !important; height: auto !important; overflow-wrap: break-word !important; ${cleanedStyle}`
          return `${start}style="${newStyle.trim()}"`
        })

      // 处理 section、div、span、p 等标签
        .replace(/(<(section|span|div|p)[^>]*?)style="([^"]*?)"/gi, (_, start, tag, style) => {
          const cleanedStyle = style
            .replace(/overflow-wrap\s*:[^;]+;?/gi, '')
            .replace(/word-break\s*:[^;]+;?/gi, '')
            .replace(/max-width\s*:[^;]+;?/gi, '')
            .trim()

          const newStyle = `overflow-wrap: break-word !important; word-break: break-word; max-width: 100%; ${cleanedStyle}`
          return `${start}style="${newStyle.trim()}"`
        })
      if (this.type === 1 || this.type === 3) {
        iqiyipromotionlinkcreateone({
          title: this.title,
          html_text: enhancedHtml,
          remark: this.remark,
          expiration_time: this.expiration_time == null ? 0 : this.expiration_time
        }).then(res => {
          console.log('res', res)
          this.$emit('updata', 1)
        })
      } else {
        iqiyipromotionlinkeditone({
          title: this.title,
          html_text: enhancedHtml,
          html_no: this.html_no,
          remark: this.remark,
          expiration_time: this.expiration_time == null ? 0 : this.expiration_time
        }).then(res => {
          console.log('res', res)
          this.$emit('updata', 2, this.html_no, this.upload_html_number)
        })
      }
    },
    handleClose() {
      this.url = ''
      this.dialogVisiblejdnjaknjw = false
    },
    daowe() {
      this.dialogVisiblejdnjaknjw = true
    },
    dawimport() {
      if (this.url === '') {
        this.$message({
          message: '请输入地址',
          type: 'error'
        })
        return
      }
      this.loading = true
      iqiyipromotionlikkwqewq({
        article_url: this.url
      })
        .then(res => {
          // console.log('res1111111111111', res.data.html)
          this.url = ''
          this.dialogVisiblejdnjaknjw = false
          this.loading = false
          this.$refs.editorwangfour.send(res.data.div, 5)
        })
        .catch(err => {
          this.loading = false
          console.log('err', err)
        })
    },
    chahuolink() {
      this.huokedialog = true
    },
    callbackhuoke(button_img, huokelink) {
      this.huokedialog = false
      const obj = { button_img: button_img, huokelink: huokelink }
      this.$refs.editorwangfour.send(obj, 8)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.dkweq {
  display: flex;
  align-items: center;
}
</style>
